import { combineReducers } from '@reduxjs/toolkit';
import {
  sidebarDefaultState,
  sidebarReducer,
  SidebarState,
} from '@slices/sidebar';
import {
  snackbarNotificationDefaultState,
  snackbarNotificationReducer,
  SnackbarNotificationState,
} from '@slices/snackbar-notification';

export type UIState = {
  sidebar: SidebarState;
  snackbarNotification: SnackbarNotificationState;
};

export const uiDefaultState: UIState = {
  sidebar: sidebarDefaultState,
  snackbarNotification: snackbarNotificationDefaultState,
};
export const uiReducer = combineReducers({
  sidebar: sidebarReducer,
  snackbarNotification: snackbarNotificationReducer,
});
